module.exports = {

    props: {
        showEmailLogin: {
            default: false
        },
        hasError: {
            default: false
        }
    },

    ready() {
        if (this.hasError) {
            this.$el.parentElement.parentElement.classList.add('shake');
        }
    }

};



// WEBPACK FOOTER //
// ./app/statamic/resources/js/components/login/login.js